import { queryOptions } from "@tanstack/react-query";
import { listAiaMembers } from "./aia.functions";

export type AiaMember = {
  id: string;
  first_name: string;
  last_name: string;
  suffix: string | null;
  name: string;
  title: string | null;
  org: string | null;
  bio: string | null;
  photo_url: string | null;
  linkedin_url: string | null;
  is_active: boolean;
  display_order: number;
  created_at: string;
  updated_at: string;
};

export function formatFullName(m: {
  first_name: string;
  last_name: string;
  suffix?: string | null;
}) {
  const base = `${m.first_name} ${m.last_name}`.trim();
  const suf = (m.suffix ?? "").trim();
  return suf ? `${base}, ${suf}` : base;
}

export const aiaQueryOptions = () =>
  queryOptions({
    queryKey: ["aia_advisory_members"],
    queryFn: async () => {
      const data = await listAiaMembers();
      return data as AiaMember[];
    },
    // Live roster query: the admin screen (which must see saves instantly)
    // and the public readers' fallback when a snippet is missing. Public
    // readers should prefer boardRosterQueryOptions / boardSnippetQueryOptions
    // (lib/board-snippet.queries.ts); this stale time keeps a fallback from
    // refetching on every mount. Admin writes invalidate the key explicitly.
    staleTime: 5 * 60_000,
  });
